export default __webpack_public_path__ + "static/media/video_guides.13412c8e.gif";